"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _rightArrow = _interopRequireDefault(require("./rightArrow.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenProviderLicense = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenProviderLicense, _React$Component);

  function FullscreenProviderLicense(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selected: null
    };
    return _this;
  }

  var _proto = FullscreenProviderLicense.prototype;

  _proto.onProviderLoaded = function onProviderLoaded(loadedData) {
    this.setState(loadedData);
  };

  _proto.render = function render() {
    var _this2 = this;

    var selected = null;

    if (this.state.selected) {
      selected = this.state.selected;
    } else if (this.props.pricingData) {
      selected = this.props.pricingData.selected;
    }

    return selected ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "pro-fullscreen-selected-license",
      onClick: function onClick() {
        _this2.props.actions.toggleMobileShopFrame();
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "pro-fullscreen-license-price"
    }, selected.price), /*#__PURE__*/_react["default"].createElement(_rightArrow["default"], {
      className: "pro-fullscreen-show-shop-frame"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pro-fullscreen-license-title"
    }, selected.title)) : null;
  };

  return FullscreenProviderLicense;
}(_react["default"].Component);

var _default = FullscreenProviderLicense;
exports["default"] = _default;